<template>
    <tr :class="{'ix-table-row-hidden-from-client': (canHide || showsHiddenFlag) && prediction.is_hidden_from_client}">
        <td class="text-center">
            <span class="ix-drag-icon handle-line"></span>
        </td>
        <td class="text-center">
            <input type="checkbox" value="1" :id="'is_title_' + prediction.uniq" :name="'predictions[' + index + '][is_title]'" v-model="prediction.is_title" @change="compute">
        </td>
        <td>
            <select :name="'predictions[' + index + '][type]'" v-model="prediction.type" class="form-control form-control-sm" :required="!prediction.is_title && prediction.designation != '' && prediction.designation != null" v-show="!prediction.is_title" @change="fillAttributeWithDefault">
                <option value="">Choisir une catégorie</option>
                <option v-for="(type, value) in types" :value="type.value">{{ type.label }}</option>
            </select>

            <select :name="'predictions[' + index + '][type_secondary]'" v-model="prediction.type_secondary" class="form-control form-control-sm mt-2" required v-if="prediction.type == 2">
                <option value="">Choisir une sous-catégorie</option>
                <option v-for="(type, value) in purchaseTypes" :value="type.value">{{ type.label }}</option>
            </select>
        </td>
        <td>
            <input type="text" class="form-control form-control-sm" :name="'predictions[' + index + '][reference]'" v-model="prediction.reference">
        </td>
        <td>
            <div class="input-group">
                <div class="input-group-prepend" v-if="prediction.article_id">
                    <!-- Un kit : l'icône déplie, sous la ligne, sa composition du jour, qui sera figée au devis. -->
                    <button type="button" class="input-group-text ix-line-kit-toggle" :class="{'is-open': prediction.kit_open}"
                            v-if="prediction.is_kit"
                            v-b-tooltip="tooltip(kit_label)"
                            @click="toggleKit">
                        <i class="far fa-cubes"></i>
                        <i class="far fa-angle-down ml-1" :class="{'fa-rotate-180': prediction.kit_open}"></i>
                    </button>
                    <span class="input-group-text" v-else><i class="far fa-cube"></i></span>
                </div>  
                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control form-control-sm" :id="'suggestionAutocomplete' + prediction.uniq" type="text" :name="'predictions[' + index + '][designation]'" v-model="prediction.designation" @input="emitEventPredictionEdited" :required="prediction.type != ''">
                <div class="input-group-append" v-if="canCreateArticle && prediction.is_title != 1">
                    <button type="button" class="ix-btn ix-btn-icon blue" v-b-tooltip="tooltip(prediction.article_id ? 'Copier en nouvel article' : 'Nouvel article')" @click="openArticleModal">
                        <i class="far fa-plus"></i>
                    </button>
                </div>
            </div>
            <input type="hidden" :name="'predictions[' + index + '][id]'" v-model="prediction.id">
            <input type="hidden" :name="'predictions[' + index + '][article_id]'" v-model="prediction.article_id">
            <input type="hidden" :name="'predictions[' + index + '][is_kit]'" :value="prediction.is_kit ? 1 : ''">
            <!-- Seuils de vente : un signal sur l'étude, le blocage motivé intervient à la transformation en devis. -->
            <div class="ix-prediction-limit" v-if="limit_breach">
                <i class="far fa-exclamation-triangle"></i> {{ limit_breach }}
            </div>
            <input type="hidden" v-if="canHide" :name="'predictions[' + index + '][is_hidden_from_client]'" :value="prediction.is_hidden_from_client ? 1 : 0">
            <div v-show="is_expanded === true">
                <textarea rows="2" class="form-control form-control-sm mt-2" placeholder="description, informations complémentaires, .." :name="'predictions[' + index + '][description]'" v-model="prediction.description"></textarea>
            </div>
        </td>
        <td colspan="5" v-if="prediction.is_title == 1"></td>
        <td v-if="prediction.is_title != 1">
            <div v-bind:class="{'input-group': prediction.type == 1 || prediction.type == 4}">
                <input type="number" class="form-control form-control-sm" :name="'predictions[' + index + '][quantity]'" v-model="prediction.quantity" @blur="quantityChanged" required step="0.001">
                <div class="input-group-append" v-if="prediction.type == 1 || prediction.type == 4">
                    <span class="input-group-text" id="inputGroup-sizing-sm">h</span>
                </div>
            </div>
            <input type="text" class="form-control form-control-sm mt-2" placeholder="unité" :name="'predictions[' + index + '][unit]'" v-model="prediction.unit" v-show="is_expanded === true" v-if="prediction.type != 1 && prediction.type != 4">
            <small class="ix-line-split-notice" v-if="split_quantity_notice" v-b-tooltip="tooltip(split_quantity_notice)">
                <i class="far fa-layer-group"></i> {{ article_total_quantity }} au total
            </small>
        </td>
        <td v-if="prediction.is_title != 1">
            <div class="input-group input-group-sm">
                <input type="number" class="form-control text-right" :name="'predictions[' + index + '][amount]'" v-model="prediction.amount" @change="compute(null)" required step="0.001">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">
                        € <span v-if="prediction.type == 1 || prediction.type == 4">&nbsp;/ h</span>
                    </span>
                </div>
            </div>
        </td>
        <td v-if="prediction.is_title != 1">
            <div class="input-group input-group-sm" v-b-tooltip="tooltip(margin_origin_label)">
                <input type="number" class="form-control text-center" :class="{'ix-prediction-margin-below': margin_below_target, 'text-danger': parseFloat(prediction.margin) < 0}" :name="'predictions[' + index + '][margin]'" v-model="prediction.margin" @change="compute('margin')" required :min="marginBounds.min" :max="marginBounds.max" step="0.01">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                </div>
            </div>
        </td>
        <td v-if="prediction.is_title != 1" class="ix-line-origin-cell">
            <div class="input-group input-group-sm" v-b-tooltip="tooltip(selling_origin_label)">
                <input type="number" class="form-control text-right" :name="'predictions[' + index + '][selling]'" v-model="prediction.selling" @change="compute('selling')" required step="0.001">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">
                        € <span v-if="prediction.type == 1 || prediction.type == 4">&nbsp;/ h</span>
                    </span>
                </div>
                <span class="ix-line-origin is-clickable"
                      :class="{'is-edited': selling_differs_from_suggestion}"
                      v-if="has_suggested_selling"
                      @click="resumeSuggestedSelling"></span>
            </div>
        </td>
        <td class="text-right" v-if="prediction.is_title != 1">{{ currency(prediction.total_selling) }}</td>
        <td class="text-center" v-if="remaining">
            <input type="checkbox" v-model="prediction.remaining_selected"  v-if="prediction.is_title != 1" @change="updateRemaining()"/>

             <span data-toggle="tooltip" class="ml-2" style="font-size:14px !important" data-placement="top" title="Prévision déjà injectée dans le reste à faire" v-show="prediction.has_remaining">
                <i class="far fa-check-square" style="color: green"></i>
            </span>


             <span data-toggle="tooltip" class="ml-2" style="font-size:14px !important" data-placement="top" title="Prévision non injectée dans le reste à faire" v-show="!prediction.has_remaining && prediction.is_title != 1">
                <i class="far fa-exclamation-square" style="color: orange" ></i>
            </span>


            <input type="hidden" :name="'predictions[' + index + '][remaining]'" v-model="prediction.sync_remaining" />
            <input type="hidden" :name="'remainings[unlocated]['+index+'][amount]'" v-if="prediction.remaining_selected" v-model="prediction.amount" />
            <input type="hidden" :name="'remainings[unlocated]['+index+'][quantity]'" v-if="prediction.remaining_selected" v-model="prediction.quantity" />
            <input type="hidden" :name="'remainings[unlocated]['+index+'][selling]'" v-if="prediction.remaining_selected" v-model="prediction.selling" />
            <input type="hidden" :name="'remainings[unlocated]['+index+'][type]'" v-if="prediction.remaining_selected" v-model="prediction.type" />
            <input type="hidden" :name="'remainings[unlocated]['+index+'][margin]'" v-if="prediction.remaining_selected" v-model="prediction.margin" />
            <input type="hidden" :name="'remainings[unlocated]['+index+'][designation]'" v-if="prediction.remaining_selected" v-model="prediction.designation" />
            <input type="hidden" :name="'remainings[unlocated]['+index+'][total]'" v-if="prediction.remaining_selected" v-model="prediction.total" />
        </td>
        <td class="text-right">
            <span class="btn btn-sm transparent" v-if="canHide" @click="toggleHiddenFromClient"
                v-b-tooltip.hover :title="prediction.is_hidden_from_client ? 'Ligne masquée dans le devis : cliquer pour l\'afficher' : 'Masquer cette ligne dans le devis'">
                <i class="far" :class="prediction.is_hidden_from_client ? 'fa-eye-slash' : 'fa-eye'"></i>
            </span>
            <span class="btn btn-sm transparent" v-else-if="showsHiddenFlag"
                v-b-tooltip.hover title="Ligne masquée dans le devis (masquage désactivé dans les paramètres)">
                <i class="far fa-eye-slash"></i>
            </span>

            <span class="btn btn-sm transparent" @click="expandRow">
                <i class="far fa-chevron-up" v-if="is_expanded === true"></i>
                <i class="far fa-chevron-down" v-if="is_expanded === false"></i>
            </span>

            <span class="btn btn-sm transparent" @click="emitEventPredictionDeleted">
                <i class="far fa-trash"></i>
            </span>
        </td>
    </tr>
</template>

<script>
    import $ from 'jquery'
    import Swal from "sweetalert2";
    import predictionPricing from './predictionPricing';

    import { marginBounds, isMarginInBounds } from './marginBounds';

    export default {
        name: 'prediction-form',
        mixins: [predictionPricing],
        props: ['prediction', 'index', 'suggestionsRoute', 'types', 'purchaseTypes', 'defaultMarginWorkforce', 'defaultMarginPurchases', 'defaultMarginStocks', 'defaultMarginEquipments', 'marginType', 'defaultHourlyRate', 'lot', 'lotIndex', 'manageRemaining', 'canCreateArticle', 'canHide', 'showsHiddenFlag'],
        data() {
            return {
                errors: [],
                is_expanded: false,
                suggestions: [],
                currentLot : this.lot ? this.lot : null,
                remaining: this.manageRemaining ? this.manageRemaining : false,
                canUpdateRemaining : false,
            };
        },
        computed: {
            kit_label: function() {
                var count = this.prediction.kit ? this.prediction.kit.components.length : 0;

                return count > 0 ? 'Article composé · ' + count + (count > 1 ? ' composants' : ' composant') : 'Article composé';
            },
            marginBounds: function() {
                return marginBounds(this.marginType);
            },
        },
        methods : {
            toggleKit: function() {
                this.$set(this.prediction, 'kit_open', !this.prediction.kit_open);
            },
            updateRemaining: function(){
                if(this.canUpdateRemaining)
                    this.prediction.sync_remaining = this.prediction.remaining_selected ? 1 : 0;

            },
            expandRow: function() {
                this.is_expanded = !this.is_expanded;
            },
            toggleHiddenFromClient: function() {
                this.$set(this.prediction, 'is_hidden_from_client', !this.prediction.is_hidden_from_client);
            },
            fillAttributeWithDefault: function() {
                if (!this.prediction.designation) {
                    var margin = 0;
                    if (this.prediction.type == 1) {
                        this.prediction.amount = this.defaultHourlyRate
                        margin = this.defaultMarginWorkforce;
                    } else if(this.prediction.type == 2) {
                        margin = this.defaultMarginPurchases
                    } else if(this.prediction.type == 3) {
                        margin = this.defaultMarginStocks
                    } else if(this.prediction.type == 4) {
                        margin = this.defaultMarginEquipments
                    }

                    this.prediction.margin = margin
                    this.compute('margin')
                }
                
            },
            /** Retourne false quand la ligne suit la politique, palier non atteint compris : elle n'est pas touchée. */
            updateMargin: function(margin) {
                if (this.follows_policy) {
                    return false
                }

                this.prediction.margin = margin
                this.compute('margin')

                return true
            },
            computeSelling: function () {
                // Taux hors bornes : prix de vente infini ou négatif, on conserve le prix actuel
                if (!isMarginInBounds(this.marginType, this.prediction.margin)) {
                    return this.prediction.selling
                }

                if (this.marginType == 2) {
                    return this.roundCurrency((parseFloat(this.prediction.amount)/(100 - parseFloat(this.prediction.margin))) * 100, 2)
                } else {
                    var marginTotal = (parseFloat(this.prediction.amount) / 100) * parseFloat(this.prediction.margin)
                    return this.roundCurrency((parseFloat(this.prediction.amount) + marginTotal), 2)
                }
            },
            computeMargin: function () {
                var marginDiff = parseFloat(this.prediction.selling) - parseFloat(this.prediction.amount)

                if (this.marginType == 2) {
                    if (parseFloat(this.prediction.selling) != 0) {
                        var divider = parseFloat(this.prediction.selling);
                    } else {
                        return 0;
                    }
                } else {
                    if (parseFloat(this.prediction.amount) != 0) {
                        var divider = parseFloat(this.prediction.amount);
                    } else {
                        return 0;
                    }
                }

                return this.roundCurrency((marginDiff/divider) * 100, 2)
            },
            compute: function(from) {
                // Prévention champs vide
                if (this.prediction.quantity == '' || this.prediction.quantity == null) { this.prediction.quantity = 0 }
                if (this.prediction.amount == '' || this.prediction.amount == null) { this.prediction.amount = 0 }
                if (this.prediction.total == '' || this.prediction.total == null) { this.prediction.total = 0 }
                if (this.prediction.margin == '' || this.prediction.margin == null) { this.prediction.margin = 0 }
                if (this.prediction.selling == '' || this.prediction.selling == null) { this.prediction.selling = 0 }
                if (this.prediction.article_id == '' || this.prediction.article_id == null) { this.prediction.article_id = null }

                if (this.prediction.is_title) {
                    this.prediction.type = ''
                    this.prediction.quantity = 1;
                    this.prediction.unit = '';
                    this.prediction.amount = 0;
                    this.prediction.total = 0;
                    this.prediction.margin = 0;
                    this.prediction.selling = 0;
                    this.prediction.total_selling = 0;
                    this.prediction.article_id = null;
                    // Plus d'article : plus de prix conseillé ni de seuil à afficher.
                    this.clearArticleData();
                } else {
                    // Le prix commande : un prix de revient saisi sur une ligne au prix de la
                    // politique recalcule la marge, pas le prix de vente.
                    if (from == null && this.follows_policy) {
                        from = 'selling'
                    }

                    if (from == null || from == 'margin') {
                        this.prediction.selling = this.computeSelling()
                    } else if (from == 'selling') {
                        this.prediction.margin = this.computeMargin() 
                    }

                    this.prediction.total = parseFloat(this.prediction.quantity) * parseFloat(this.prediction.amount)
                    this.prediction.total_selling = parseFloat(this.prediction.quantity) * parseFloat(this.prediction.selling)
                }
            },
            /** Une suggestion choisie, depuis l'autocomplete ou après la création d'un article. */
            fillFromSuggestion(item) {
                this.prediction.reference = item.reference
                this.prediction.designation = item.designation
                this.prediction.unit = item.unit
                this.prediction.amount = item.amount
                this.prediction.selling = item.selling
                this.prediction.description = item.description
                this.prediction.is_title = item.is_title
                this.prediction.lot_id = item.lot_id
                this.prediction.article_id = item.article_id ? item.article_id : null;

                // Une ligne d'article n'est jamais masquée au client.
                if (this.prediction.article_id && this.prediction.is_title != 1) {
                    this.$set(this.prediction, 'is_hidden_from_client', false);
                }
                this.$set(this.prediction, 'is_kit', !!item.is_kit);
                this.$set(this.prediction, 'kit', item.kit || null);
                this.$set(this.prediction, 'kit_open', false);

                var net = this.applyPricingSuggestion(item)
                if (net !== null) {
                    this.prediction.selling = net
                }

                this.compute('selling');
            },
            /** Une copie de l'article de la ligne, ou un article neuf repris de la saisie libre. */
            openArticleModal() {
                var source = this.prediction.article_id
                    ? { article_id: this.prediction.article_id, article_name: this.prediction.designation }
                    : {
                        designation: this.prediction.designation,
                        reference: this.prediction.reference,
                        unit: this.prediction.unit,
                        description: this.prediction.description,
                        amount: this.prediction.selling != 0 ? this.prediction.selling : null,
                    };

                this.$emit('open-article-modal', { source: source, done: article => this.loadArticle(article.id) });
            },
            /** L'article créé arrive comme une suggestion choisie, au tarif du client de l'étude. */
            loadArticle(articleId) {
                $.ajax({
                    url: this.suggestionsRoute,
                    type: 'get',
                    dataType: 'json',
                    headers: this.getHttpJsonRequestHeaders().headers,
                    data: { article_id: articleId, deal_id: $('#deal_id').val(), company_id: $('#company_id').val() },
                    success: (data) => {
                        if (!data.length) return;

                        this.fillFromSuggestion(data[0]);
                        this.emitEventPredictionEdited();
                    }
                });
            },
            emitEventPredictionEdited: function () {
                this.$emit('prediction-editing-started', {
                    'index' : this.index,
                })
            },
            emitEventPredictionDeleted: function () {
                Swal.fire({
                    title: 'Êtes-vous sûr ?',
                    text: "",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#D15240',
                    confirmButtonText: 'Oui, supprimer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.$emit('prediction-deleted', {
                            'index' : this.index,
                        })
                    }
                })
            }
        },
        mounted() {
            // Expand si description
            if (this.prediction.description) {
                this.is_expanded = true;
            }

            if(!this.prediction.has_remaining)
                this.canUpdateRemaining = true;

            if (this.canHide) {
                this.$set(this.prediction, 'is_hidden_from_client', this.prediction.is_hidden_from_client == 1);
            }

            this.prediction.total = parseFloat(this.prediction.quantity) * parseFloat(this.prediction.amount)
            this.prediction.total_selling = parseFloat(this.prediction.quantity) * parseFloat(this.prediction.selling)

            //this.compute()

            var vm = this

            // Creation autocomplete
            $("#suggestionAutocomplete" + this.prediction.uniq).autocomplete({
                minLength: 2,
                source: (request, response) => {
                    $.ajax({
                        url : this.suggestionsRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, deal_id: $('#deal_id').val(), company_id: $('#company_id').val() },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                    formatted_amount: this.currency(item.amount)
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        return $('<li>')
                            .append(vm.studySuggestionItemHtml(item))
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if(!item.item){ 
                        this.prediction.article_id = null
                        this.clearArticleData()
                    }
                },
                select: (e, item) => {
                    this.fillFromSuggestion(item.item);
                }
            }).focus(() => {
                $("#suggestionAutocomplete" + this.prediction.uniq).autocomplete("search", '');
            });
        }
    }
</script>


<style>
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Pour Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
</style>